module.exports = __webpack_public_path__ + "img/lp.dad4a93c.png";